<script setup lang="ts">
  import { fmt } from '@/functions'

  defineProps<{
    services: ServiceItem[],
  }>()
</script>

<template>
  <router-link
    v-for="service in services"
    :key="service.id"
    class="flex items-center px-4 py-2 space-x-4 hover:bg-primary hover:text-white"
    :to="{ name: 'service detail', params: { id: service.id, name: service.name } }">
    <app-img
      :src="service.images[0]?.url_xs"
      :alt="'jasa-' + service.name"
      class="size-14" />
    <div class="">
      <div class="text-sm font-medium">
        {{ service.name }}
      </div>
      <div class="text-xs">
        Rp {{ fmt.number(service.price) }} / {{ service.unit }}
      </div>
    </div>
  </router-link>
</template>
